import classNames from "classnames"
import type { ActivityItem } from "../useSortedFeedItems"
import { FavoriteFeedItem } from "./FavoriteFeedItem"
import styles from "./FeedItem.module.scss"
import { UserEntryFeedItem } from "./UserEntryFeedItem"
import { UserEventFeedItem } from "./UserEventFeedItem"
import { useFollowedUsers } from "src/contexts"
import type {
  FavoriteUserEntry,
  ReadOnlyUserEvent,
  ReadOnlyUserEntry,
} from "src/types"

interface Props {
  activityItem: ActivityItem;
}

/*
 * this component renders an activity as either an event or an entry
 * with the relevant header and details
 */
export function FeedItem(props: Props) {
  const { activityItem } = props
  const className = classNames(
    styles.container,
    {
      [styles.first]: activityItem.isFirst,
      [styles.last]: activityItem.isLast,
    },
  )

  const { selfFollow } = useFollowedUsers()

  const userEvent = activityItem.activity as ReadOnlyUserEvent
  if (userEvent.event_type) {
    return (
      <UserEventFeedItem
        className={className}
        userEvent={userEvent}
      />
    )
  }

  const userEntry = activityItem.activity as ReadOnlyUserEntry

  if (userEntry.entry_template_id && userEntry.account_id === selfFollow.account_id) {
    return (
      <FavoriteFeedItem
        className={className}
        userEntry={userEntry as FavoriteUserEntry}
      />
    )
  }

  return (
    <UserEntryFeedItem
      className={className}
      userEntry={userEntry}
    />
  )
}
